<div [ngClass]="{'alertbox-modal': alertdisplay == 'modal', 'alertbox-confirm': alerttype == 'confirm'}"
    class="alertbox">
    <div *ngIf="alerttype == 'success'" class="alert alert-success text-center lh-24 align-middle" role="alert">
        <span class="material-icons lh-24 align-middle pr-2 f-20" style="padding-bottom: 2px;">
            {{alerticon}}
        </span>
        <b>{{alerttext}}!</b>
    </div>

    <div *ngIf="alerttype == 'error'" class="alert alert-danger text-center lh-24 align-middle" role="alert">
        <span class="material-icons lh-24 align-middle pr-2 f-20 cursor-pointer" style="padding-bottom: 4px;">
            {{alerticon}}
        </span>
        <b style="font-weight: 800;">{{alerttext}}!</b>
    </div>

    <div *ngIf="alerttype == 'confirm'" class="alert alert-secondary lh-24 align-middle" role="alert">
        <div class="text-center mb-3">
            <span class="material-icons lh-24 align-middle pr-2 f-20" style="padding-bottom: 2px;">
                {{alerticon}}
            </span>
            <strong>{{alerttext}}</strong>
        </div>
        <div *ngIf="confirmmessage" class="mb-3 f-15" style="white-space: pre-line;">
            {{confirmmessage}}
        </div>
        <div class="text-center">
            <button type="button" (click)="onCancel()" class="btn btn-secondary-style mr-2">
                <h6 class="btn-text lh-20 pl-3 pr-3 mb-0">{{cancelButtonText}}</h6>
            </button>
            <button type="button" (click)="onConfirm()" class="btn btn-danger-style">
                <h6 class="btn-text lh-20 pl-3 pr-3 mb-0">{{confirmButtonText}}</h6>
            </button>
        </div>
    </div>

    <div *ngIf="alerttype == 'comment'" class="alert alert-light lh-24 align-middle border"
        style="border-width: 2px!important;" role="alert">
        <div class="row" style="margin-top: -5px;">
            <div class="col text-center">
                <b style="font-size: 14px;">Project name</b>
                <span class="material-icons lh-24 align-middle pr-2 f-20 pl-2">
                    {{alerticon}}
                </span>
            </div>
        </div>
        <div class="row">
            <div class="col-auto">
                <app-personimage></app-personimage>
            </div>
            <div class="col align-middle pl-0" style="line-height: 37px; padding-top: 3px;">
                Is the comment text, from a user
            </div>
        </div>
    </div>
</div>